export default class DropdownEvent extends CustomEvent<null> {
  currentOption: HTMLElement | undefined;

  constructor(currentOption?: HTMLElement) {
    super('dropdown:change', { bubbles: true, detail: null });

    this.currentOption = currentOption;
  }
}
